import classNames from "classnames"
import React, { useState } from "react"
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import { useTranslation } from "react-i18next"

const offer = {
  id: "ID-254832555",
  name: "Offer Title",
  category: "Category Name",
  createdAt: "25 dec, 2022",
  startDate: "22 jul, 2025",
  endDate: "22 jul, 2025",
  periodFrom: "10:00 am.",
  periodTo: "01:00 pm.",
  price: 2000,
  productsCount: 3,
  state: true,
  items: ["bottle 500 ml", "bottle 1.5 l", "gallon"],
  visibility: true,
  subImage: [
    {
      id: "1",
      cover: true,
      imgSrc:
        "https://img.freepik.com/premium-photo/mineral-water-bottle-water-glass-with-spash-blue-background-with-copy-space-vertical-format_138656-1131.jpg?w=360",
    },
    {
      id: "2",
      cover: false,
      imgSrc:
        "https://i.pinimg.com/736x/a9/ee/32/a9ee32f627c6105ea0968fe47afe5d89.jpg",
    },
  ],
  composition1: [
    {
      name: "PH",
      value: "7.1",
    },
    {
      name: "Sodium",
      value: "7.5",
    },
    {
      name: "Potassium",
      value: "20",
    },
  ],
  composition2: [
    {
      name: "Calcium",
      value: "36",
    },
    {
      name: "Sulphate",
      value: "24",
    },
    {
      name: "Tds",
      value: "175",
    },
  ],
}
const OfferDetailsSection = () => {
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = useState("0")
  const [copied, setCopied] = useState(false)

  const toggleTab = (tab: string) => {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }

  const imageShow = (img: string, id: number) => {
    const expandImg = document.getElementById("expandedImg" + id)
    if (expandImg) {
      ;(expandImg as HTMLImageElement).src = img
    }
  }

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 1500) // يختفي بعد 1.5 ثانية
    })
  }

  const removeItem = (index: number) => {
    console.log(index)
  }

  return (
    <Card className="shadow-md rounded-3">
      <CardBody>
        <Row>
          <Col xl={4}>
            <div className="campaign-detai-imgs">
              <TabContent activeTab={activeTab}>
                {offer.subImage.length &&
                  offer.subImage.map((item, index) => (
                    <TabPane tabId={index.toString()} key={item.id}>
                      <div
                        className="m-auto"
                        style={{
                          maxHeight: "337px",
                          width: "300px",
                          overflow: "hidden",
                        }}
                      >
                        <img
                          src={item.imgSrc}
                          alt=""
                          id="expandedImg1"
                          className="img-fluid mx-auto d-block w-100"
                        />
                      </div>
                    </TabPane>
                  ))}
              </TabContent>
              <Nav
                className="flex bg-transparent bg-none justify-content-center"
                pills
              >
                {offer.subImage.length &&
                  offer.subImage.map((item, index) => (
                    <NavItem key={item.id}>
                      <NavLink
                        className={classNames(
                          {
                            active: activeTab === index.toString(),
                          },
                          "p-1 position-relative overflow-hidden"
                        )}
                        onClick={() => {
                          toggleTab(index.toString())
                        }}
                        style={{ width: "62px", height: "62px" }}
                      >
                        <img
                          src={item.imgSrc}
                          alt=""
                          onClick={() => {
                            imageShow(item.imgSrc, index + 1)
                          }}
                          className="img-fluid mx-auto d-block rounded w-100"
                        />
                        <button
                          className="position-absolute p-0 border-0 translate-middle text-danger fw-bold bg-white rounded-circle text-center"
                          style={{
                            top: "15px",
                            left: "45px",
                            width: "16px",
                            height: "16px",
                          }}
                        >
                          <i className="bx bx-x bx-xs fw-bolder "></i>
                        </button>
                        {item.cover && (
                          <p
                            className="position-absolute m-auto w-90 text-semi-dark fw-bold bg-semi-white-60 rounded-2 text-center font-size-10 px-2"
                            style={{ bottom: "10px", left: "8px" }}
                          >
                            {t("common_cover")}
                          </p>
                        )}
                      </NavLink>
                    </NavItem>
                  ))}
              </Nav>
            </div>
          </Col>

          <Col xl="8">
            <div className="mt-4 mt-xl-3">
              <div className="d-flex justify-content-between">
                <div className="d-flex flex-column align-items-start gap-1">
                  <h4 className="text-semi-dark fw-semibold m-0">
                    {offer.name}
                  </h4>
                  <span className="text-muted">
                    {t("common_createdAt")}: {offer.createdAt}
                  </span>
                </div>
                <p className="badge bg-primary-30 text-primary font-size-12 h-50 px-2 py-1 m-0">
                  {offer.state ? t("common_active") : t("common_inactive")}
                </p>
              </div>
              <Row>
                <Col
                  md={3}
                  className="col-form-label text-start flex align-items-center fw-semibold "
                >
                  {t("offers_offerId")}
                </Col>
                <Col
                  md={9}
                  className="d-flex align-items-center col-form-label text-start"
                >
                  <p className="text-muted  m-0">{offer.id}</p>
                  <button
                    className="relative cursor-pointer border-0 bg-transparent"
                    onClick={() => {
                      copyToClipboard(offer.id)
                    }}
                  >
                    <i className="bx bx-copy px-2 text-primary bx-sm cursor-pointer"></i>
                    {copied && (
                      <span
                        className="position-absolute  translate-middle-x mt-1 text-success small"
                        style={{ top: "14px", marginLeft: "20px" }}
                      >
                        {t("common_copied")}
                      </span>
                    )}
                  </button>
                </Col>
              </Row>
              {/* Price */}
              <Row>
                <Col
                  md={3}
                  className="col-form-label text-start flex align-items-center fw-semibold "
                >
                  {t("common_price")}
                </Col>
                <Col
                  md={9}
                  className="d-flex align-items-center col-form-label text-start"
                >
                  <p className="text-muted fw-semibold m-0">
                    {t("common_qar")} {offer.price}
                  </p>
                </Col>
              </Row>
              {/* Category */}
              <Row>
                <Col
                  md={3}
                  className="col-form-label text-start flex align-items-center fw-semibold "
                >
                  {t("offers_offerCategory")}
                </Col>
                <Col
                  md={9}
                  className="d-flex align-items-center col-form-label text-start"
                >
                  <p className="text-muted fw-semibold m-0">{offer.category}</p>
                </Col>
              </Row>

              {/* products count */}
              <Row>
                <Col
                  md={3}
                  className="col-form-label text-start flex align-items-center fw-semibold"
                >
                  {t("campaigns_productsCount")}
                </Col>
                <Col
                  md={9}
                  className="d-flex align-items-center col-form-label text-start"
                >
                  <p className="text-muted m-0">{offer.productsCount}</p>
                </Col>
              </Row>
              {/* Products Items */}
              <Row>
                <Col
                  md={3}
                  className="col-form-label text-start flex align-items-center fw-semibold"
                >
                  {t("offers_offerItems")}
                </Col>
                <Col
                  md={9}
                  className="d-flex align-items-center col-form-label text-start"
                >
                  <div className="d-flex gap-2 mb-4">
                    {offer.items &&
                      offer.items.map((item, index) => (
                        <span
                          key={index}
                          className="badge bg-primary-30 text-primary font-size-12 p-1"
                        >
                          {item}
                          <Button
                            className="bg-transparent border-0 text-primary p-0 my-0 mx-1 "
                            style={{ lineHeight: "1" }}
                            onClick={() => {
                              removeItem(index)
                            }}
                          >
                            <i className="bx bx-x bx-xs fw-bolder "></i>
                          </Button>
                        </span>
                      ))}
                  </div>
                </Col>
              </Row>

              {/* Start & End Date */}
              <Row>
                <Col
                  xs={3}
                  className="col-form-label text-start flex align-items-center fw-semibold"
                >
                  {t("common_startDate")}
                </Col>
                <Col
                  xs={9}
                  className="align-items-center col-form-label text-start justify-content-center"
                >
                  <Row>
                    <Col xs={4}>
                      <p className="text-muted m-0">{offer.startDate}</p>
                    </Col>
                    <Col
                      xs={4}
                      className="col-form-label text-start align-items-center fw-semibold p-0"
                    >
                      {t("common_endDate")}
                    </Col>
                    <Col xs={4}>
                      <p className="text-muted m-0">{offer.endDate}</p>
                    </Col>
                  </Row>
                </Col>
              </Row>

              {/* Period From | To */}
              <Row>
                <Col
                  xs={3}
                  className="col-form-label text-start flex align-items-center fw-semibold"
                >
                  {t("offers_periodFrom")}
                </Col>
                <Col
                  xs={9}
                  className="align-items-center col-form-label text-start justify-content-center"
                >
                  <Row>
                    <Col xs={4}>
                      <p className="text-muted m-0">{offer.periodFrom}</p>
                    </Col>
                    <Col
                      xs={4}
                      className="col-form-label text-start align-items-center fw-semibold p-0"
                    >
                      {t("offers_periodTo")}
                    </Col>
                    <Col xs={4}>
                      <p className="text-muted m-0">{offer.periodTo}</p>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <div className="d-flex gap-2 align-items-center mt-4">
                <p className="text-semi-dark text-start">
                  <b>{t("offers_offerActive")}</b>
                  <span> ({t("offers_inactivePeriod")})</span>
                </p>
                <div className="form-check form-switch mb-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id={`customSwitch${offer.id}`}
                    checked={offer.visibility}
                    onChange={() => {}}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

export default OfferDetailsSection
